import { createAction } from '@reduxjs/toolkit';

export const saveExperiment = createAction<{ name: string; group: string }>(
  'featureFlags/SAVE_EXPERIMENT',
);
